import {
  AggregateDataverseChartDataSource,
  AggregateType,
  ChartDateGrouping,
  ChartType,
  type ChartClickEventArgs,
} from '@powerportalspro/react-charts';
import { DataverseChart } from '@powerportalspro/react-fluent';
import { useT } from '@powerportalspro/react';
import { useMemo, useState } from 'react';

// Reuses the Blazor demo's localization keys so both stacks share the
// JSON. Framework flattens to `components.<FullTypeName>.<key>`.
const STRINGS_BASE =
  'components.PowerPortalsPro.Demo.Client.Customizations.Pages.Charts.BarChart.BarChartDataverseDemo';

export function BarChartDataverseSample() {
  const t = useT();
  const [lastClick, setLastClick] = useState<ChartClickEventArgs | null>(null);
  // `useMemo` keeps the source object's identity stable so DataverseChart
  // doesn't re-fetch on every render — changes to TableName /
  // GroupByColumn etc. are applied at mount only.
  const source = useMemo(
    () =>
      new AggregateDataverseChartDataSource({
        tableName: 'opportunity',
        groupByColumn: 'actualclosedate',
        groupByDateGrouping: ChartDateGrouping.Year,
        aggregateColumn: 'estimatedvalue',
        aggregate: AggregateType.Sum,
        seriesColumn: 'statecode',
        filterXml:
          "<filter><condition attribute='statecode' operator='ne' value='0' /></filter>",
      }),
    [],
  );
  return (
    <>
      <DataverseChart
        dataSource={source}
        type={ChartType.Bar}
        title={t(`${STRINGS_BASE}.chart-title`)}
        stacked
        yAxisPrefix="$"
        onElementClick={setLastClick}
      />
      {lastClick && (
        <p style={{ marginTop: '12px' }}>
          <strong>{t(`${STRINGS_BASE}.clicked-label`)}:</strong>{' '}
          {lastClick.datasetLabel} — {lastClick.label} — ${lastClick.value.toLocaleString()}
        </p>
      )}
    </>
  );
}
